import { initializeApp } from 'firebase/app';
import { getDatabase } from 'firebase/database';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyDVX_nrLRgRRdYIprJmsgdHqVyx7uP6XyI",
  authDomain: "chill-ras.firebaseapp.com",
  databaseURL: "https://chill-ras-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "chill-ras",
  storageBucket: "chill-ras.firebasestorage.app",
  messagingSenderId: "524433472913",
  appId: "1:524433472913:web:f530727236078a1e05ee30"
};

const app = initializeApp(firebaseConfig);
export const db = getDatabase(app);
export const auth = getAuth(app);

// Secondary app instance, used ONLY for creating manager accounts from
// ManageManagers.js. Firebase's client SDK signs the current user out and
// switches sessions the moment you call createUserWithEmailAndPassword on
// the primary `auth` instance — this isolated instance avoids kicking the
// admin who's creating the account.
const secondaryApp = initializeApp(firebaseConfig, 'Secondary');
export const secondaryAuth = getAuth(secondaryApp);
